export const userConstants = {
  USERID: 'USER_ID',
  CLIENTID: 'CLIENT_ID',
  CLIENTUSERID: 'CLIENT_USER_ID',
  USERUSERID: 'USER_USER_ID',
  ROLEARRAY: 'ROLE_ARRAY',
  CLEAR: 'CLEAR',
};
